import React, { useState } from 'react'
import NoQuoteSadImage from 'src/assets/Buy_Policy_Images/NoQuoteSadImage.svg'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import * as Yup from 'yup'
import {
  NAME_REGEX,
  PHONE_REGEX,
  VEHICLE_NUMBER_REGEX,
} from 'src/utils/constants/BuyPolicyMotor'
import { useFormik } from 'formik'
import { CONTACT_FORM_ERROR_MESSAGES } from 'src/utils/constants/ValueAddedServicesData'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { fallbackVehicleInfo } from 'src/services/buyPolicyMotorService'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import LoadingModal from 'src/components/common/LoadingModal'
import { getTokenForQrReport } from 'src/services/individualService'
import { useDispatch } from 'react-redux'
import {
  SUBMITTEED_WILL_GET_BACK_SOON,
  VEHICLE_DETAILS,
  vehicleTypes,
} from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { ENCOUNTERED_ERROR } from 'src/utils/constants/Ceo'

const NoPreFilledData = ({ handleClose, number, vehicleType }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const defaultVehicleModal =
    vehicleTypes?.find((type) => type?.value === vehicleType)?.value || ''

  const initialValues = {
    name: '',
    phone: '',
    email: '',
    vehicleNumber: number || '',
    vehicleModal: defaultVehicleModal || '',
  }

  const contactForm = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.NAME_REQUIRED)
        .matches(NAME_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_NAME),
      phone: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.PHONE_REQUIRED)
        .matches(PHONE_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .max(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .min(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE),
      email: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.EMAIL_REQUIRED)
        .email(CONTACT_FORM_ERROR_MESSAGES?.VALID_EMAIL),
      vehicleNumber: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.VEHICLE_NUMBER)
        .matches(
          VEHICLE_NUMBER_REGEX,
          CONTACT_FORM_ERROR_MESSAGES?.VALID_VEHICLE_NUMBER
        ),
      vehicleModal: Yup.string().required(
        CONTACT_FORM_ERROR_MESSAGES?.VEHICLE_MODAL
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true)
      handleSubmit(values)
    },
    enableReinitialize: true,
  })

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      const tokenResponse = await getTokenForQrReport()
      if (tokenResponse?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      } else {
        const token = tokenResponse?.res?.data?.access_token
        await fallBack(token, values)
      }
    } catch (error) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: VEHICLE_DETAILS,
        })
      )
    }
  }

  const fallBack = async (token, values) => {
    setLoading(true)
    const formData = {
      name: values?.name,
      mobile: values?.phone,
      email: values?.email,
      vehicleNumber: values?.vehicleNumber,
      vehicleType: values?.vehicleModal,
    }

    try {
      const response = await fallbackVehicleInfo(token, formData)
      if (response?.status !== 201) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.SUCCESS,
          message: SUBMITTEED_WILL_GET_BACK_SOON,
        })
      )
      handleClose()
    } catch (err) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ENCOUNTERED_ERROR,
        })
      )
    }
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.closeButtonContainer}>
        <IconButton onClick={handleClose} id='closeNoPrefilledDataButton'>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.noDetailsContainer}>
        <div className={classes.noDetailsContent}>
          <img
            src={NoQuoteSadImage}
            alt='Not Found'
            className={classes.notFoundImage}
          />
          <div className={classes.notFoundText}>
            <div>
              We couldn&apos;t find any details for the provided vehicle number.
            </div>
            <div> So, Please fill out the following details.</div>
          </div>
        </div>
        <div className={classes.formContainer}>
          <form onSubmit={contactForm.submitForm}>
            <div className={classes.formContent}>
              <div className={classes.formInput}>
                <FormControl fullWidth size='small'>
                  <TextField
                    id='name'
                    name='name'
                    type='text'
                    label='Name'
                    placeholder='Name'
                    value={contactForm?.values?.name}
                    onChange={contactForm.handleChange}
                    required
                    size='small'
                    error={isFormControlError(contactForm, 'name')}
                    helperText={getFormControlErrorText(contactForm, 'name')}
                  />
                </FormControl>

                <FormControl fullWidth size='small'>
                  <TextField
                    id='phone'
                    name='phone'
                    type='number'
                    label='Phone'
                    placeholder='Phone'
                    value={contactForm?.values?.phone}
                    onChange={(event) => {
                      const onlyNums = event?.target?.value?.replace(
                        /[^0-9]/g,
                        ''
                      )
                      event.target.value = Math.max(0, parseInt(onlyNums))
                        ?.toString()
                        ?.slice(0, 10)
                      contactForm.handleChange(event)
                    }}
                    required
                    size='small'
                    error={isFormControlError(contactForm, 'phone')}
                    helperText={getFormControlErrorText(contactForm, 'phone')}
                  />
                </FormControl>

                <FormControl fullWidth size='small'>
                  <TextField
                    id='email'
                    name='email'
                    type='text'
                    label='E-mail'
                    placeholder='E-mail'
                    value={contactForm?.values?.email}
                    onChange={contactForm.handleChange}
                    required
                    size='small'
                    error={isFormControlError(contactForm, 'email')}
                    helperText={getFormControlErrorText(contactForm, 'email')}
                  />
                </FormControl>

                <FormControl fullWidth size='small'>
                  <TextField
                    id='vehicleNumber'
                    name='vehicleNumber'
                    type='text'
                    label='Vehicle Number'
                    placeholder='Vehicle Number'
                    value={contactForm?.values?.vehicleNumber}
                    onChange={contactForm.handleChange}
                    required
                    size='small'
                    error={isFormControlError(contactForm, 'vehicleNumber')}
                    helperText={getFormControlErrorText(
                      contactForm,
                      'vehicleNumber'
                    )}
                  />
                </FormControl>

                <FormControl fullWidth size='small'>
                  <InputLabel id='vehicleModal-label'>Vehicle Type</InputLabel>
                  <Select
                    id='vehicleModal'
                    name='vehicleModal'
                    placeholder='Vehicle Type'
                    label='Vehicle Type'
                    value={contactForm?.values?.vehicleType || vehicleType}
                    onChange={contactForm.handleChange}
                    onBlur={contactForm.handleBlur}
                    error={isFormControlError(contactForm, 'vehicleModal')}
                    helperText={getFormControlErrorText(
                      contactForm,
                      'vehicleModal'
                    )}
                    required
                    size='small'
                    className={classes.vehicleModelField}
                  >
                    <MenuItem
                      value={''}
                      className={'default-menu-item'}
                      disabled
                    >
                      Vehicle Type
                    </MenuItem>
                    {vehicleTypes?.map((type) => (
                      <MenuItem key={type?.id} value={type?.value}>
                        {type?.option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </form>
          <div>
            <Button
              variant='outlined'
              className={classes.submitButton}
              onClick={() => {
                contactForm.submitForm()
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
export default NoPreFilledData

const useStyles = makeStyles({
  noDetailsContainer: {
    display: 'flex',
    // flexDirection: 'column',
    // width: '70%',
    // height: '70%',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    padding: '30px',
    gap: '10px',
    backgroundColor: 'white',
  },
  notFoundImage: {
    width: '100%',
    height: '100%',
    maxHeight: '200px',
    maxWidth: '200px',
  },
  vehicleModelField: {
    textAlign: 'left',
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
    },
  },
  notFoundText: {
    textAlign: 'center',
    fontSize: '18px',
    fontStyle: 'italic',
    opacity: '50%',
    fontWeight: 'bold',
    paddingTop: '20px',
  },

  closeButtonContainer: {
    position: 'absolute',
    right: '0px',
    cursor: 'pointer',
  },
  closeButton: {
    width: '30px',
    height: '30px',
  },

  notProvidingContainer: {
    alignItems: 'center',
    justifySelf: 'center',
  },

  formContainer: {
    textAlign: 'center',
    padding: '50px 10px',
    width: '100%',
  },

  formContent: {
    display: 'flex',
    gap: '10px',
    paddingBottom: '10px',
  },

  formInput: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
  },

  submitButton: {
    color: '#b92250 !important',
    border: '1px solid #ef669b !important',
    backgroundColor: ' #ffffff !important',
    textTransform: 'unset !important',
  },

  noDetailsContent: {
    textAlign: 'center',
    width: '100%',
  },
})
